import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { FontSizes, Radius, Spacing } from 'chatie-design-system';

import Modal, { ModalButton, ModalProps } from '@components/common/Modal';

const FanClubModalCSS = (theme: Theme) => css`
  text-align: center;
  line-height: 1.35;

  h5 {
    margin-bottom: ${Spacing.medium}px;
  }

  p {
    font-size: ${FontSizes.xsmall}px;
    white-space: pre-line;
    color: ${theme.var.gray800};
    padding: ${Spacing.xsmall}px;
    border-radius: ${Radius.medium}px;
    font-size: ${FontSizes.small}px;
    color: ${theme.var.gray600};
  }
`;

const FanClubModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal {...props} header={false}>
      <div css={FanClubModalCSS}>
        <h5>{t('팬클럽')}</h5>
        <p>{t('작가님의 작품을 후원하여\n작가님의 팬클럽에 가입해주세요!.')}</p>
      </div>
      <ModalButton text={t('확인')} />
    </Modal>
  );
};

export default FanClubModal;
